<div class="dialog-box">
  <h1 mat-dialog-title>{{data.name}}</h1>
  <div mat-dialog-content>
    <!-- <p>Presso la nostra agenzie potrai effettuare tutte le operazioni riguardanti il rinnovo della patente di guida. Evita file e lunghe attese.</p> -->
    <p>{{data.detail}}</p>
      <ul *ngIf="data.come !== null"> 
        <li>{{data.come}}</li>
        <li>{{data.chi}}</li>
      </ul>

    <!-- <mat-form-field>
      <mat-label>Favorite Animal</mat-label>
      <input matInput [(ngModel)]="data.animal">
    </mat-form-field> -->
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button class="default-btn2" style="color: white;" (click)="onNoClick()">CLOSE</button>
    <!-- <button mat-button cdkFocusInitial>Ok</button> -->
  </div>
</div>